import { render } from "./EmailSubscription.vue?vue&type=template&id=02d3696c"
import script from "./EmailSubscription.vue?vue&type=script&lang=js"
export * from "./EmailSubscription.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__